import React, { useEffect, useState } from 'react';

import lang from '../../lang/lang';

import Button from '../UI/Button/Button';
import Modal from '../Modal/Modal';

import { TodoListStyled, TodoListWrapperStyled, TodoListItemStyled, Index, Text } from './TodoList.styled';

const TodoList = () => {
    const [todoList, setTodoList] = useState(JSON.parse(localStorage.getItem('todoList')) || []);
    const [modalIsOpened, setModalIsOpened] = useState(false);
    const [langState, setLangState] = useState(localStorage.getItem('language') || 'en')


    useEffect(() => {
        if(localStorage.getItem('todoList')) {
            setTodoList(JSON.parse(localStorage.getItem('todoList')));
        } else {
            setTodoList([]);
        }
    }, [localStorage.getItem('todoList')]);

    const handleClearAllClick = () => {
        document.body.style.overflowY = 'hidden';
        setModalIsOpened(true);
    }

    const closeModal = () => {
        document.body.style.overflow = 'auto';
        setModalIsOpened(false);
    }

    const handleConfirm = () => {
        localStorage.removeItem('todoList');
        document.location.reload();
    }

    const handleTodoListItemClick = item => {
        item.completed = !item.completed;
        
        let todoList = JSON.parse(localStorage.getItem('todoList'));
        const id = item.id;
        const todoItemIndex = todoList.findIndex(todo => todo.id === id);
        
        todoList.splice(todoItemIndex, 1, item);
        localStorage.setItem('todoList', JSON.stringify(todoList));
    }

    return <>
        <TodoListWrapperStyled>
           <TodoListStyled>
               {todoList.length > 0 ? <Button 
                    danger
                    text={todoList.length > 1 ? langState === 'uk' ? lang.uk.clearAll : lang.en.clearAll : langState === 'uk' ? lang.uk.clear : lang.en.clear}
                    onClick={handleClearAllClick}
               /> : null}
               {todoList.map((item, index) => <TodoListItemStyled key={item.id} onClick={() => handleTodoListItemClick(item)} completed={item.completed}>
                   <Index>{index + 1}.</Index>
                    <Text>{item.text}</Text>
               </TodoListItemStyled>)}  
           </TodoListStyled>
        </TodoListWrapperStyled>
        <Modal 
            text={langState === 'uk' ? lang.uk.modal.text : lang.en.modal.text}
            title={langState === 'uk' ? lang.uk.modal.title : lang.en.modal.title}
            open={modalIsOpened}
            onClose={closeModal}
            closeBtn={false}
            onConfirm={handleConfirm}
        />
    </>;
}

export default TodoList;